import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class Footer extends Component {
  static propTypes = {

  };

  render() {
    return (
      <div className="common-footer">
        <p className="company">© immoquipo 2020</p>
        <div className="right">
          <Link className="link" to="/mentions-legales">Mentions légales</Link>
          <p className="link" onClick={this.props.onContact}>Contact</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/Footer.js